import { useSettings } from "@/contexts/SettingsContext";
import {
    resolveWhatsAppDigits,
    resolvePhoneDisplay,
    resolveTelHref,
    FALLBACK_EMAIL,
} from "@/lib/contact";

/** Contact details from backend settings with sensible fallbacks. */
export function useSiteContact() {
    const { settings } = useSettings() || {};
    const s = settings || {};
    return {
        email: s.support_email || FALLBACK_EMAIL,
        phoneDisplay: resolvePhoneDisplay(s),
        phoneTel: resolveTelHref(s),
        whatsappDigits: resolveWhatsAppDigits(s),
        whatsappUrl: `https://wa.me/${resolveWhatsAppDigits(s)}`,
    };
}
